import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import {MinPlayersValidator} from 'services/validations/validators/min-players-validator';
import {MinPlayersOnPositionValidator} from 'services/validations/validators/min-players-on-position-validator';
import {MinTeamsValidator} from 'services/validations/validators/min-teams-validator';
import {MinGamesValidator} from 'services/validations/validators/min-games-validator';
import {MaxLockedPlayersSalaryValidator} from 'services/validations/validators/max-locked-players-salary-validator';
import {MaxExposedPlayersSalaryValidator} from 'services/validations/validators/max-exposed-players-salary-validator';
import {MaxLockedPlayersValidator} from 'services/validations/validators/max-locked-players-validator';
import {MaxLockedPlayersOnPositionValidator} from 'services/validations/validators/max-locked-players-on-position-validator';
import BaseValidator from 'services/validations/base-validator';

class ClassicValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            playersData: {preparedPlayers, players},
            playersLock,
            sportConfig,
        } = Action.getState();

        const playersDividedByPosition = preparedPlayers.groupedBy.position();
        const playersIndexedById = preparedPlayers.groupedBy.playerId();
        const playersGroupedByExposureMin = preparedPlayers.groupedBy.property('exposureMin');

        const minPlayersValidator = new MinPlayersValidator();
        minPlayersValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
            playersLock,
        });

        const minPlayersOnPositionValidator = new MinPlayersOnPositionValidator();
        minPlayersOnPositionValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
        });

        const minTeamsValidator = new MinTeamsValidator();
        minTeamsValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
        });

        const minGamesValidator = new MinGamesValidator();
        minGamesValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
        });

        const maxLockedPlayersValidator = new MaxLockedPlayersValidator();
        maxLockedPlayersValidator.setDependencies({
            sportConfig,
            playersLock,
        });

        const maxLockedPlayersOnPositionValidator = new MaxLockedPlayersOnPositionValidator();
        maxLockedPlayersOnPositionValidator.setDependencies({
            sportConfig,
            playersLock,
            playersDividedByPosition,
            playersIndexedById,
        });

        const maxLockedPlayersSalaryValidator = new MaxLockedPlayersSalaryValidator();
        maxLockedPlayersSalaryValidator.setDependencies({
            sportConfig,
            players,
            playersLock,
        });

        const maxExposedPlayersSalaryValidator = new MaxExposedPlayersSalaryValidator();
        maxExposedPlayersSalaryValidator.setDependencies({
            sportConfig,
            playersGroupedByExposureMin,
        });

        const validator = new BaseValidator();
        validator.addSubValidators([
            minPlayersValidator,
            minPlayersOnPositionValidator,
            minTeamsValidator,
            minGamesValidator,
            maxLockedPlayersSalaryValidator,
            maxExposedPlayersSalaryValidator,
            maxLockedPlayersValidator,
            maxLockedPlayersOnPositionValidator,
        ]);

        return validator;
    }
}

export {ClassicValidatorBuilder};
